import React from "react";

import Autocomplete from "veneer/AutocompleteSelectInput";
import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";

import { FormData } from "cortex/ui/src/fleet/view/device/model";
import { NumberOption } from "cortex/ui/src/ui/table/types";

import FallbackContentSelector from "./FallbackContentSelector";

const TYPE_OPTIONS = {
  device: {
    helperText:
      "The application your device plays. To play ads from the Ad Server, select the UAS app or VSA.",
    title: "Fallback Creative(s)",
  },
  network: {
    helperText: "The application your network's devices play by default.",
    title: "Network Fallback Creative(s)",
  },
} as const;

type StrategyFormType = keyof typeof TYPE_OPTIONS;

interface SystemStrategyFormProps {
  applicationOptions: ReadonlyArray<NumberOption>;
  onChange: (nextValue: Partial<FormData>) => void;
  readOnly?: boolean;
  type: StrategyFormType;
  value: FormData;
}

export default function SystemStrategyForm({
  applicationOptions,
  onChange,
  readOnly = false,
  type = "device",
  value,
}: SystemStrategyFormProps) {
  const update = (patch: Partial<SystemStrategyFormProps["value"]>) => {
    onChange({ ...value, ...patch });
  };

  return (
    <Stack spacing={2}>
      <Autocomplete
        disabled={readOnly}
        getOptionKey={(opt) => opt.value}
        inputProps={{
          helperText: TYPE_OPTIONS[type].helperText,
          label: "Application",
          sx: {
            "& .MuiAutocomplete-inputRoot": { backgroundColor: Colors.white },
          },
        }}
        isOptionEqualToValue={(opt, val) => opt.value === val.value}
        onChange={(_e, opt) => {
          if (!opt) {
            update({ fallbackContents: [], selectedApplication: null });
          } else {
            update({ selectedApplication: opt });
          }
        }}
        options={applicationOptions}
        size="small"
        value={value.selectedApplication}
      />
      <FallbackContentSelector
        fallbackContent={value.fallbackContents}
        readOnly={readOnly}
        setFallbackContent={(nextValue) =>
          update({ fallbackContents: nextValue })
        }
      />
    </Stack>
  );
}
